var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Styles from './button-kv-styles.scss';
import React from 'react';
import { CircleSpinner } from '..';
import classNames from 'classnames';
const ButtonKVBase = (_a) => {
    var { type = 'button', btnBackgroundGradient = 'linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)', loading = false, width, height, testId, rightIcon, rightIconClass, leftIcon, leftIconClass, dropDownMenu = null, btnWrapClass, inactivePointerEvents = false } = _a, props = __rest(_a, ["type", "btnBackgroundGradient", "loading", "width", "height", "testId", "rightIcon", "rightIconClass", "leftIcon", "leftIconClass", "dropDownMenu", "btnWrapClass", "inactivePointerEvents"]);
    const invalidBtn = props.disabled || loading;
    return (React.createElement("div", { className: classNames(Styles.btnWrap, btnWrapClass) },
        React.createElement("button", Object.assign({ type: type }, props, { disabled: invalidBtn, style: { background: !invalidBtn && btnBackgroundGradient && btnBackgroundGradient, width, height }, "data-testid": testId, className: invalidBtn || inactivePointerEvents ? Styles.disabledClass : '' }),
            !loading && leftIcon && (React.createElement("div", { className: classNames(leftIconClass) }, invalidBtn ? React.cloneElement(leftIcon, { color: '#999' }) : leftIcon)),
            loading && (React.createElement("div", null,
                React.createElement(CircleSpinner, { size: 20 }))),
            React.createElement("div", { className: classNames(Styles.btnChild, invalidBtn ? Styles.btnChildDisabled : '') }, props.children),
            rightIcon && (React.createElement("div", { className: classNames(rightIconClass) }, invalidBtn ? React.cloneElement(rightIcon, { color: '#999' }) : rightIcon))),
        dropDownMenu));
};
export default ButtonKVBase;
